<template>
  <div class="c-searchTitle">
    <h1
      aria-controls="seoDescription"
      @click="toggleSeoDescription()"
    >
      <!--カテゴリやfreeword_search_seos定義の場合-->
      <span
        v-if="seo.title"
        class="c-searchTitleCaption"
        :class="{ 'c-searchTitleCaption-category' : isCategoryPage }"
      >
        <span
          v-if="isCategoryPage && categoryIcon"
          class="c-searchTitleIcon"
        >
          <CoconalaIcon
            :name="`category-${categoryIcon}`"
            size="28px"
          />
        </span>

        <span v-html="seo.title"></span>
        <span v-if="$route.query.keyword && !seo.parentKeyword">
          （{{ totalCountText }}件）
        </span>
      </span>

      <span
        v-else
        class="c-searchTitleCaption"
      >
        <span v-html="titleDefault"></span>
        <span>（{{ totalCountText }}件）</span>
      </span>

      <CoconalaIcon
        :name="isDescriptionOpen ? 'chevron-up' : 'chevron-down'"
        size="12px"
        v-if="seo.description && !isLoggedIn && isFirstPage"
      />
    </h1>
    <BCollapse
      aria-id="seoDescription"
      :open.sync="isDescriptionOpen"
      v-if="seo.description && !isLoggedIn && isFirstPage"
    >
      <p class="c-seoDescription">
        {{ seo.description }}
      </p>
    </BCollapse>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

const TITLE_DEFAULT = '<em>すべてのカテゴリ</em>からの検索結果'

export default {
  name: 'SearchTitle',
  props: {
    seo: {
      type: Object
    },
    isCategoryPage: {
      type: Boolean
    },
    totalCountText: {
      type: String
    },
    parentCategoryId: {
      type: Number,
      default: null
    },
    pageNumber: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isDescriptionOpen: true,
      titleDefault: TITLE_DEFAULT
    }
  },
  computed: {
    ...mapState('master', ['masterCategories']),
    ...mapGetters('ui', ['isPC']),
    ...mapGetters('auth', ['isLoggedIn']),
    categoryIcon() {
      if (this.parentCategoryId) {
        return this.masterCategories.find(c => c.id === this.parentCategoryId).romaji
      }
      return ''
    },
    isFirstPage() {
      return this.pageNumber === 1
    }
  },
  watch: {
    isPC(newValue) {
      if (newValue) {
        this.isDescriptionOpen = true
      }
    }
  },
  methods: {
    toggleSeoDescription() {
      if (this.seo.description && !this.isPC) {
        this.isDescriptionOpen = !this.isDescriptionOpen
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-searchTitle {
  margin-bottom: 8px;
  font-size: 24px;
  line-height: 1.3;
  color: $ds2-color-gray-900;
}

.c-searchTitleIcon {
  display: inline-block;
  width: 30px;
}

.c-searchTitleCaption {
  &-category {
    font-weight: bold;
  }

  /deep/ em {
    margin-right: 4px;
    font-weight: bold;
    font-style: normal;
  }
  /deep/ strong {
    font-weight: bold;
  }

  & + .coconala-icon {
    display: none;
  }
}

.c-seoDescription {
  margin-top: 4px;
  margin-bottom: 0;
  font-size: 11px;
  color: $color-gray-700;
}

@media (max-width: breakpoint(Search, M)) {
  .c-searchTitle {
    margin-bottom: 0;
    min-height: 32px;
    background: $color-white;
    font-size: 16px;

    &-folded {
      padding-bottom: 4px;
    }

    h1 {
      padding: 0 12px 4px;
      color: $color-font-base;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
    }

    .c-seoDescription {
      margin-top: 12px;
      padding: 8px 12px 8px;
      background-color: $color-gray-50;
      font-size: 11px;
      color: $color-gray-700;
    }
  }

  .c-searchTitleCaption {
    & + .coconala-icon {
      display: block;
    }
  }
}
</style>
